import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OverlayModule, ConnectionPositionPair } from '@angular/cdk/overlay';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [CommonModule, RouterModule, OverlayModule],
  templateUrl: './navigation.component.html',
})
export class NavigationComponent {
  @Input() isMobileNav = false;

  private readonly _isMoreMenuOpen = signal(false);
  readonly isMoreMenuOpen = this._isMoreMenuOpen.asReadonly();

  // Position strategy for the overlay (above button, aligned right)
  readonly overlayPositions: ConnectionPositionPair[] = [
    new ConnectionPositionPair(
      { originX: 'end', originY: 'top' },
      { overlayX: 'end', overlayY: 'bottom' },
      0,
      -8
    ),
    new ConnectionPositionPair(
      { originX: 'start', originY: 'top' },
      { overlayX: 'start', overlayY: 'bottom' },
      0,
      -8
    ),
    new ConnectionPositionPair(
      { originX: 'end', originY: 'bottom' },
      { overlayX: 'end', overlayY: 'top' },
      0,
      8
    ),
  ];

  isMoreMenu(): boolean {
    return this._isMoreMenuOpen();
  }

  toggleMoreMenu(): void {
    this._isMoreMenuOpen.update(open => !open);
  }

  closeMoreMenu(): void {
    this._isMoreMenuOpen.set(false);
  }
}
